import React, { createContext, ReactNode, useContext, useState } from 'react'

export namespace ModalSpace {
  export interface ModalData {
    type?: 'default' | 'rop03' | 'rop04'
    when?: boolean
    contents?: {
      title?: string
      desc?: string
      children?: ReactNode
    }
    button?: {
      cancel?: { text: string; func?: () => unknown }
      submit?: { text: string; func?: () => unknown }
    }
  }

  export interface ModalContextValue {
    isOpen: boolean
    openModal: (modalData: ModalData) => unknown
    closeModal: () => unknown
    modalData: ModalData
  }
}

const modalInitialValue: ModalSpace.ModalData = {
  when: true,
  contents: {
    title: '',
    desc: '',
    children: <></>,
  },
  button: {
    cancel: {
      text: '취소',
      func: () => {},
    },
    submit: {
      text: '확인',
      func: () => {},
    },
  },
}

const ModalContextValue = {
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
  modalData: modalInitialValue,
}

const ModalContext = createContext<ModalSpace.ModalContextValue>(ModalContextValue)

export const ModalContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalData] = useState<ModalSpace.ModalData>(modalInitialValue)

  const openModal = (ModalData: ModalSpace.ModalData) => {
    setIsOpen(true)
    setModalData({
      ...ModalData,
      when: !ModalData.when ? true : ModalData.when,
    })
  }

  const closeModal = () => {
    setIsOpen(false)
    setModalData(modalInitialValue)
  }

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal, modalData }}>
      {children}
    </ModalContext.Provider>
  )
}

export function useModal() {
  return useContext(ModalContext)
}
